<template>
  <div>
    <form @submit.prevent="submit">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Nombre">
            <b-form-input
           
              type="text"
              v-model="vacante.nombre"
              placeholder="Desarrollador web"
              data-vv-validate-on="blur|input"
              data-vv-name="nombre"
              v-validate.initial="'required'"
              :state="!errors.has('nombre')"
            />
            <span class="text-danger fs-6" v-show="errors.has('nombre')"
              >El campo es obligatorio</span
            >
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Departamento">
            <b-form-input
              class="form-control"
              type="text"
              v-model="vacante.departamento"
              placeholder="TI"
              data-vv-validate-on="blur|input"
              data-vv-name="departamento"
              v-validate.initial="'required'"
              :state="!errors.has('departamento')"
            />
            <span class="text-danger fs-6" v-show="errors.has('departamento')"
              >El campo es obligatorio</span
            >
          </b-form-group>
        </b-col>
      </b-row>
 <!--formulario vancantes nuevos campos -->
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Descripcion">
            <b-form-input
           
              type="text"
              v-model="vacante.descripcion"
              placeholder="Descripcion de la Vacante"
              data-vv-validate-on="blur|input"
              data-vv-name="descripcion"
              v-validate.initial="'required'"
              :state="!errors.has('descripcion')"
            />
            <span class="text-danger fs-6" v-show="errors.has('descripcion')"
              >El campo es obligatorio</span
            >
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Requisitos">
            <b-form-input
              class="form-control"
              type="text"
              v-model="vacante.tarea"
              placeholder="Requisitos del puesto"
              data-vv-validate-on="blur|input"
              data-vv-name="tarea"
              v-validate.initial="'required'"
              :state="!errors.has('tarea')"
            />
            <span class="text-danger fs-6" v-show="errors.has('tarea')"
              >El campo es obligatorio</span
            >
          </b-form-group>
        </b-col>
      </b-row>

       <!--formulario vancantes nuevos campos -->
       <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Sucursal">
            <b-form-input
           
              type="text"
              v-model="vacante.sucursal"
              placeholder="Sucursal"
              data-vv-validate-on="blur|input"
              data-vv-name="sucursal"
              v-validate.initial="'required'"
              :state="!errors.has('sucursal')"
            />
            <span class="text-danger fs-6" v-show="errors.has('sucursal')"
              >El campo es obligatorio</span
            >
          </b-form-group>
        </b-col>
      
      </b-row>

      <div class="text-right">
        <b-button type="submit" variant="success">Crear vacante</b-button>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  props: {
    cleanForm: {
      type: Date,
    },
  },
  data() {
    return {
      vacante: {
        nombre: "",
        departemtento: "",
        descripcion:"",
        tarea:"",
        sucursal:""
      },
    };
  },
  methods: {
    submit() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$emit("handleCreateVacant", this.vacante);
        }
      });
    },
  },

  watch: {
    cleanForm() {
      this.vacante = {
        nombre: "",
        departemtento: "",
        descripcion:"",
        tarea:"",
        sucursal:""
      };
    },
  },
};
</script>
<style scoped></style>
